import React from 'react';
import { Box, TableCell, TableRow } from '@mui/material';
import { NoRecordFound } from '../NoRecordFound/NoRecordFound';

const TableNoRecords = () => {
  return (
    <TableRow>
      <TableCell colSpan={12} align="center" sx={{ height: '70vh' }}>
        <Box
          data-testid="norecords-container"
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%">
          <NoRecordFound />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default TableNoRecords;
